require('backbone');


var ShapeUtils = require('../../../shapeUtils');


/*
*   Properties used in drawing and persisting the box.
*   Padding, strokeWidth, fontSize now stored in pts, not pixels;
*
* */



module.exports = Backbone.Model.extend({

    defaults: {

        points: [],

        padding: +( ShapeUtils.ptToTenthsMM(5).toFixed(3) ), // point equivalent of 5; really: 17.639 -- round down ?

        /*
         * strokeWidth:
         * Raphael doesn't scale stroke width correctly, see hack in codesView to overcome this.
         * Now in 1/10 mm to store as a physical dimension.
         * Must be at least 1 so we don't get < 1 pixel value -- fractional pixel won't be rendered by the browser as some round down (1px would be 0.75pt).
         * Value of 1 will convert to 1.33 if dpi is not taken into account -- so leave at 1 like doing b/f with pixels.
         * This will be more apparent now that we are scaling the stroke-width, especially at images of higher DPI. ...
         * FDD start with adjusted 2px value;  I think do in pts in case we ever have a picker -- just convert pt values (dpi independent)
         * One pt converted to 1/10 mm -- really 3.528-- may not want to be a decimal ... still problematic ???
         * */

        strokeWidth: +(ShapeUtils.ptToTenthsMM(1).toFixed(3) ),

        // properties not involved with positioning the coordinates -- MAY WANT A 'BOX' OBJECT THAT GETS PASSED IN FROM THE NOTE MODEL
        fill: '#fffbcc', //html yellow, though intertwined with transparency if we ever start using it --
        fillOpacity: 1.0,
        stroke: '#000000', // black: looks like other software has one
        strokeOpacity: 0.35, // name the same as the line (black with this opacity) ///0.2, // may as well make grey

        // those applied to text el ... again, maybe a diff obj
        font: 'Arial',

        fontSize: 9, // Points: equivalent of 12 pixels (which was using b/f) and people deemed good

        textColor: '#000000',
        textAlign: 'left',  // horizontal alignment of the text in the box, i don't think we want; I'm currently assuming everything is left -- THIS IS TEXT ANCHOR, IF CHANGE WHAT TO DO
        lineHeight: 1.2

    },

    getPoints: function() {
        return this.get('points');
    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/models/coordinate/redaction/floating/codeBox.js
 ** module id = 249
 ** module chunks = 0
 **/